<template>
  <CModal
      :show.sync="addTicketAnswerModal"
      :centered="true"
      title="پاسخ به تیکت"
      size="md"
      class="text-right"
  >
    <CRow class="px-2">
      <CCol sm="6" class="text-right">
        <div class="mb-3"><span class="bold">نام:</span>
          {{ ticket.userType === 'STUDENT' ? ticket.student.name : ticket.teacher.name }}
        </div>
        <div class="mb-3"><span class="bold">نقش:</span>
          <span v-if="ticket.userType === 'STUDENT'"> دانش آموز</span>
          <span v-if="ticket.userType === 'TEACHER'"> معلم</span></div>

      </CCol>
      <CCol sm="6" class="text-right">
        <div class="mb-3"><span class="bold">نام خانوادگی:</span>
          {{ ticket.userType === 'STUDENT' ? ticket.student.lastname : ticket.teacher.lastname }}
        </div>
        <div class="mb-3"><span class="bold">تاریخ ارسال:</span> {{ addDate }}</div>

      </CCol>
    </CRow>
    <div class="mb-3"><span class="bold">موضوع:</span> {{ ticket.title }}</div>
    <div class="ticket-desc mb-3"><span class="bold">متن:</span> {{ ticket.text }}</div>

    <CForm class="add-ticket-modal text-right">
      <CTextarea v-model="response" label="پاسخ شما" class="text-sm"/>
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          @click="onAddTicketAnswer"
          color="primary"
          class="px-5"
      >
        ثبت
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    value: {
      type: Boolean,
    },
    ticket: {
      type: Object,
    }
  },
  data() {
    return {
      response: '',
      loading: false,
    };
  },
  computed: {
    addTicketAnswerModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    addDate() {
      return this.ticket.addDate.replaceAll('-', '/')
    },
  },
  watch: {
    addTicketAnswerModal(newValue) {
      if (newValue)
        this.response = this.ticket.response
    }
  },
  methods: {
    async onAddTicketAnswer() {
      try {
        this.loading = true;
        const payload = {
          response: this.response,

        };
        await axios.put(`/ticket/${this.ticket.id}`, payload);
        this.response = '';
        this.addTicketAnswerModal = false;
        this.$emit("get-ticket");
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-desc {
  word-wrap: break-word;
  white-space: pre-line;
}
</style>